import React, { useState } from 'react';
import { Button, useNotify, useDataProvider } from 'react-admin';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { pushEventToFirebase, pushLayoutToFirebase } from '../../services/firebasePushService';
import { useFirebasePushAuth } from './FirebasePushGate';
import { getEventDbId } from '../../utils/eventIdentity';

/**
 * GECICI buton: kaydi ayni ID ile Firebase'e push (varsa uzerine yazar).
 * mode: 'event' | 'layout'
 * Admin123! sifresi olmadan push yapilamaz.
 */
export const FirebasePushButton = ({ mode, record }) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);
  const { requirePushPassword, PushPasswordDialog } = useFirebasePushAuth();

  if (!record?.id) return null;

  const label =
    mode === 'layout'
      ? 'Push Layout → Firebase (geçici)'
      : 'Push Event → Firebase (geçici)';

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;

    const pushRecord =
      mode === 'layout'
        ? record
        : { ...record, id: getEventDbId(record) };
    const firebaseKey = pushRecord.id;

    const ok = window.confirm(
      mode === 'layout'
        ? `Layout Firebase'e yazılacak (aynı id üzerine):\nlayouts/${firebaseKey}\n\nFormdaki güncel plan kullanılır.\nDevam?`
        : `Event + stock + eventLayout (+ layout) Firebase'e yazılacak (aynı id üzerine):\nevents-v2/${firebaseKey}\n\nÖnce panelde Save ettiğinden emin ol (API'deki kayıt push edilir).\nDevam?`,
    );
    if (!ok) return;

    if (!(await requirePushPassword())) {
      notify('Firebase push iptal (şifre gerekli)', { type: 'warning' });
      return;
    }

    setLoading(true);
    try {
      if (mode === 'layout') {
        const latest = { ...record };
        const result = await pushLayoutToFirebase(latest);
        notify(
          `Firebase OK: layouts/${result.id} (${result.existed ? 'overwrite' : 'create'})`,
          { type: 'success' },
        );
      } else {
        const result = await pushEventToFirebase(pushRecord, dataProvider);
        const summary = (result.pushed || [])
          .map((p) => `${p.collection}/${p.id}${p.existed ? '↑' : '+'}`)
          .join(', ');
        notify(`Firebase OK: ${summary || result.eventId}`, { type: 'success' });
      }
    } catch (err) {
      console.error('Firebase push error:', err);
      notify(`Firebase push hata: ${err?.message || err}`, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {PushPasswordDialog}
      <Button
        label={loading ? 'Pushing…' : label}
        onClick={handleClick}
        disabled={loading}
        startIcon={<CloudUploadIcon />}
        variant="contained"
        style={{
          backgroundColor: '#b45309',
          color: '#fff',
          marginLeft: 12,
          whiteSpace: 'nowrap',
        }}
      />
    </>
  );
};

export default FirebasePushButton;
